var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.507 14.667h6.986c1.84 0 2.574-1.127 2.66-2.5L14.5 6.66A2.5 2.5 0 0 0 12 4c-.407 0-.78-.233-.967-.593l-.48-.967c-.306-.606-1.106-1.106-1.786-1.106H7.24c-.687 0-1.487.5-1.793 1.106l-.48.967C4.78 3.767 4.407 4 4 4a2.5 2.5 0 0 0-2.5 2.66l.347 5.507c.08 1.373.82 2.5 2.66 2.5M7 5.334h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 12a2.17 2.17 0 0 0 2.167-2.167A2.17 2.17 0 0 0 8 7.667a2.17 2.17 0 0 0-2.166 2.166A2.17 2.17 0 0 0 8 12"
  })));
};
export default SvgCamera;